export default {
    header: "Vous avez été déconnecté avec succès",
    message: ""
}